import type { NodeProps } from '@xyflow/react';
import { NodeShell } from './nodeShell';

export function NoteNode({ data, selected }: NodeProps) {
  const d = data as { title?: string; vaultLink?: string; summary?: string };
  return (
    <NodeShell title={d.title ?? 'Note'} kind="note" accent="#226d24" selected={selected}>
      {d.summary && <div>{d.summary}</div>}
      {d.vaultLink && <div style={{ marginTop: 2, color: '#0066cc' }}>[[{d.vaultLink}]]</div>}
    </NodeShell>
  );
}
